export class User {
    constructor({
        accessToken = '', isMaster = false, tenantName = '', tenantIcon = '', module = '', masterToken = '', userId = 0
    } = {}) {
        this.accessToken = accessToken;
        this.isMaster = isMaster;
        this.tenantName = tenantName;
        this.tenantIcon = tenantIcon;
        this.module = module;
        this.masterToken = masterToken;
        this.id = userId;
        this.adSoyad = '';
    }


}
